import { FC } from 'react';
import classNames from 'classnames';

interface LoanFormatIconProps {
    icon: string;
    className?: string;
}

export const LoanFormatIcon: FC<LoanFormatIconProps> = props => {
    const { icon, className } = props;
    return (
        <span className="gild">
            <span className={classNames('icon', icon, className)} />
        </span>
    );
};
